import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");

const LeaveTypeSelect = React.forwardRef(({ employeeId, onChange }, ref) => {
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [placeholder, setPlaceholder] = useState("Select Leave Type");

  const selectRef = useRef(null);

  useEffect(() => {
    const fetchLeaveTypes = async () => {
      if (!employeeId) return; // If employeeId is not set, don't fetch
      setLeaveTypes([]); // Clear leave types on error

      try {
        const response = await axios.get(`${apiUrl}/leaves/leave-balance-emp/${employeeId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.error) {
          // If an error is received, clear the options and show the placeholder
          setLeaveTypes([]); // Clear leave types
          setPlaceholder("No Leave Types Available"); // Set placeholder for no data
          selectRef.current.clearValue(); // Explicitly clear the selected value
        } else {
          setPlaceholder("Select Leave Type"); // Reset to default placeholder
          setLeaveTypes([]); // Clear leave types
          const { leaveData } = response.data;
          const transformedLeaveTypes = leaveData.map((leaveType) => ({
            value: leaveType.leave_type_id,
            label: leaveType.type,
            balance: leaveType.balance, // Assuming the API returns balance for each leave type
          }));
          selectRef.current.clearValue(); // Explicitly clear the selected value

       

          setLeaveTypes(transformedLeaveTypes);
        }
      } catch (error) {
        console.error("Error fetching leave types:", error);
        setLeaveTypes([]); // Clear leave types on error
        setPlaceholder("No Leave Types Available"); // Set placeholder for error case
        selectRef.current.clearValue(); // Explicitly clear the selected value
      } finally {
        setLoading(false);
      }
    };

    if (apiUrl && token && employeeId) {
      fetchLeaveTypes();
    }
  }, [token, employeeId]); // Include employeeId as a dependency



  const handleSelectChange = (selectedOption) => {
    if (selectedOption) {
      onChange(selectedOption); // Pass the selected option back to the parent component if it's not null
    } else {
      onChange(null); // Handle the case where the selected option is null (no leave types available)
    }
  };
  
  // Custom styles for the Select component
const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: '#f9f9f9', // Apply background color
    borderColor: '#ddd', // Apply border color
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // Ensure dropdown appears above other elements
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#666666', // Customize placeholder color
  }),
};


  return (
    <Select
      ref={selectRef}
      options={leaveTypes}
      isLoading={loading}
      onChange={handleSelectChange}
      styles={customStyles}
      placeholder={placeholder}
    />
  );
});



export default LeaveTypeSelect;
